import { insuranceValueLayerStyle } from './insuranceValue'

export const layerStyles = {
  insuranceValue: insuranceValueLayerStyle,
}
